// 告警和预警列表页
import React, { useState, useEffect } from "react";
import { alarmApi, stationApi, dictApi } from "@api/newApi";
import { connect } from "react-redux";
import {
  Tabs,
  Form,
  Radio,
  Select,
  DatePicker,
  Pagination,
  Modal,
  Tooltip,
  Upload,
  message,
  Spin,
  Input,
  Button,
} from "antd";
import moment from "moment";
import classnames from "classnames";
import * as echarts from "echarts";
import "./index.scss";
import AssetImg from "../../assets/device.png";
import defaultImg from "../../assets/default-img.png";
import finishImg from "../../assets/finish.png";
const { UPLOADER } = window.globalConfig;

const Pages = ({ userInfo, history }) => {
  const { TabPane } = Tabs;
  // 处理状态
  const alarmStatusOpt = [
    { id: 0, name: "未读" },
    { id: 1, name: "处理中" },
    { id: 2, name: "已完成" },
  ];
  // 厂站集合
  const [stationArr, setstationArr] = useState([]);
  // 获取厂站列表
  const getStationList = () => {
    stationApi
      .selectStationNameList(
        userInfo.stationIds ? userInfo.stationIds.split(",") : []
      )
      .then((res) => {
        if (res.status * 1 === 0) {
          let data = [{ id: -1, name: "全部" }, ...res.data];
          setstationArr(data);
        }
      });
  };
  // 告警状态及数量值
  const [statusCount, setStatusCount] = useState({});
  // 获取告警数量
  const getAlarmCount = () => {
    alarmApi
      .selectAllAlarmNum(
        userInfo.stationIds ? userInfo.stationIds.split(",") : []
      )
      .then((res) => {
        if (res.status * 1 === 0) {
          setStatusCount(res.data);
        }
      });
  };
  // 告警类型集合
  const [alarmTypeOpt, setalarmTypeOpt] = useState([]);
  // 获取告警类型数据
  const getAlarmTypeData = () => {
    dictApi
      .selectWithClassifyKey({
        classifyKey: "alarmClassify",
        classifyKeys: [""],
      })
      .then((res) => {
        if (res.status * 1 === 0) {
          setalarmTypeOpt(res.data);
        }
      });
  };
  useEffect(() => {
    getAlarmTypeData();
    getAlarmCount();
    getStationList();
  }, []);

  // 筛选条件
  const [form] = Form.useForm();
  const [formInitVals, setformInitVals] = useState({
    pageNum: 1,
    pageSize: 10,
    alarmLevel: -1,
    alarmStatus: -1,
    alarmType: -1,
    // dutyUserName: userInfo.name, //当前责任人名称
    queryEndTime: null, //告警时间-查询结束时间
    queryStartTime: null, //告警时间-查询开始时间
    stationIds: [-1],
  });

  // 厂站点击事件
  const onTabClick = (key, e) => {
    let idx = key.split("-")[1];
    setformInitVals({
      ...formInitVals,
      stationIds: [stationArr[idx].id],
    });
  };

  // 表单项值改变事件
  const onFormLayoutChange = (data) => {
    let date = {};
    for (const key in data) {
      if (Object.hasOwnProperty.call(data, key)) {
        if (key == "queryEndTime") {
          if (data[key]) {
            date.queryStartTime =
              moment(data[key][0]).format("YYYY-MM-DD") + " 00:00:00";
            date.queryEndTime =
              moment(data[key][1]).format("YYYY-MM-DD") + " 23:59:59";
          } else {
            date.queryStartTime = null;
            date.queryEndTime = null;
          }
        }
      }
    }
    setformInitVals({ ...formInitVals, ...data, ...date });
  };

  // 分页页码改变事件
  const pageChange = (page, pSize) => {
    setformInitVals({
      ...formInitVals,
      pageNum: page,
    });
  };

  // 表格数据
  const [tableData, setTableData] = useState([]);
  const [total, setTotal] = useState(0); //总条数
  const [spinLoading, setSpinLoading] = useState(false); // 表格数据是否加载中

  // 获取分页数据
  const getData = (data) => {
    setSpinLoading(true);
    data.alarmStatus = data.alarmStatus == -1 ? null : data.alarmStatus;
    data.alarmType = data.alarmType == -1 ? null : data.alarmType;
    data.alarmLevel = data.alarmLevel == -1 ? null : data.alarmLevel;
    // if (data.queryEndTime != null) {
    //   data.queryEndTime += ' 23:59:59';
    //   data.queryStartTime += ' 00:00:00';
    // }
    data.stationIds =
      data.stationIds[0] * 1 == -1
        ? (userInfo.stationIds ? userInfo.stationIds.split(",") : [])
        : data.stationIds;
    alarmApi.selectAlarmByPage({ ...data }).then((res) => {
      setSpinLoading(false);
      if (res.status * 1 === 0) {
        setTotal(res.data.total * 1);
        setTableData(res.data.data);
      }
    });
  };
  useEffect(() => {
    getData(formInitVals);
  }, [formInitVals]);

  // 告警详情数据
  const [alarmDetailData, setalarmDetailData] = useState({
    alarmDetailInfo: {},
    alarmCurveSnapList: null,
    alarmHandleList: [],
  });
  // 列表行点击事件
  const rowClk = (id) => {
    alarmApi
      .selectAlarmDetail({
        dutyUserName: userInfo.realName,
        alarmId: id,
      })
      .then((res) => {
        if (res.status * 1 == 0) {
          setalarmDetailData(res.data);
          setIsShowDetailModal(true);
          // 获取水质echarts数据
          if (res.data.alarmDetailInfo.alarmTypeName == "水质告警") {
            let data = res.data.alarmCurveSnapList;
            showBar(data, "waterWarningBox");
          }
        }
      });
  };
  // 关闭告警
  const closeAlarmBtn = (item) => {
    alarmApi
      .closeAlarm({
        alarmId: item.id,
        userId: userInfo.id,
        userName: userInfo.realName,
      })
      .then((res) => {
        if (res.status * 1 == 0) {
          message.success(res.message);
          rowClk(item.id);
          getData(formInitVals);
        }
      });
  };
  // 详情弹窗
  const [isShowDetailModal, setIsShowDetailModal] = useState(false);

  // 水质告警图表
  const showBar = (data, echart) => {
    let timeData = data.map(
      (item) => (item.updateTime = item.updateTime.substr(5, 11))
    );
    let seriesData = data.map((item) => item.alarmValue);
    let yData = JSON.parse(JSON.stringify(seriesData));
    // y轴最大值
    let max = yData.sort((a, b) => b - a)[0] + 5;
    let option = {
      color: ["#3398DB"],
      tooltip: {
        trigger: "axis",
        axisPointer: {
          // 坐标轴指示器，坐标轴触发有效
          type: "line", // 默认为直线，可选为：'line' | 'shadow'
        },
      },
      dataZoom: [
        {
          type: "inside",
          show: true,
          realtime: true,
          start: 30,
          end: 70,
          // xAxisIndex: [0, 1]
        },
        {
          type: "slider",
          show: true,
          realtime: true,
          start: 30,
          end: 70,
          bottom: 0,
          showDetail: true,
          // xAxisIndex: [0, 1]
        },
      ],
      grid: {
        top: "10%",
        bottom: "30px",
        right: "10%",
        left: "10%",
      },
      xAxis: [
        {
          type: "category",
          data: timeData,
          axisTick: {
            //轴刻度线
            show: false,
          },
          axisLine: {
            lineStyle: {
              width: "0", //坐标线的宽度
            },
          },
          axisLabel: {
            // interval: 0,
            textStyle: {
              color: "#5A5F64", //坐标值得具体的颜色
              fontSize: "14",
              textAlign: "center",
            },
          },
        },
      ],
      yAxis: [
        {
          type: "value",
          max,
          min: 0,
          splitNumber: 4,
          axisLine: {
            lineStyle: {
              width: "0", //坐标线的宽度
            },
          },
          axisTick: {
            //轴刻度线
            show: false,
          },
          axisLabel: {
            textStyle: {
              color: "#5A5F64", //坐标值得具体的颜色
              fontSize: "14",
            },
          },
        },
      ],
      series: [
        {
          name: "值",
          data: seriesData,
          type: "line",
          symbol: "circle", //标记的图形
          smooth: true, //是否平滑曲线显示
          sampling: "average",
          itemStyle: {
            borderWidth: 2,
            borderColor: "#F2C022",
            color: "#F2C022",
          },
          lineStyle: {
            width: 2,
            color: "#F2C022",
          },
          areaStyle: {
            color: {
              type: "linear",
              x: 0,
              y: 0,
              x2: 0,
              y2: 1,
              colorStops: [
                {
                  offset: 0,
                  color: "rgba(242, 192, 34, 0.45)", // 100% 处的颜色
                },
                {
                  offset: 1,
                  color: "rgba(242, 192, 34, 0)", // 0% 处的颜色
                },
              ],
            },
          },
        },
      ],
    };
    let dom = document.getElementById(`${echart}`);
    if (dom) {
      let myChart = echarts.init(dom);
      // 绘制图表
      myChart.setOption(option);
    }
  };

  // 处理告警提交的图片列表
  const [imgList, setImgList] = useState([]);
  const handleChange = ({ file, fileList }) => {
    if (file.status === "done" || file.status === "removed") {
      setImgList(fileList);
    }
    setImgList(fileList);
  };

  const [handleTxt, sethandleTxt] = useState("");
  const changeHandleTxt = (e) => {
    sethandleTxt(e.target.value);
  };
  // 提交处理记录
  const submitHandleLogBtn = () => {
    if (handleTxt == "") {
      message.error("请填写处理意见。");
      return false;
    }
    const handleAttach = imgList.map((mm) => mm.response.data.url);
    let data = {
      alarmId: alarmDetailData.alarmDetailInfo.id,
      handleAttach: handleAttach.join(","),
      handleIdea: handleTxt,
      userName: userInfo.realName,
    };
    alarmApi.handleIdea(data).then((res) => {
      if (res.status * 1 == 0) {
        message.success("提交成功");
        sethandleTxt("");
        setImgList([]);
        rowClk(alarmDetailData.alarmDetailInfo.id);
      }
    });
  };

  return (
    <div className="warn-page baseContent">
      <div className="head">
        <div className="item">
          <p>未读</p>
          <p className="num">{statusCount.unreadAlarmNum}</p>
        </div>
        <div className="item">
          <p>处理中</p>
          <p className="num">{statusCount.processingAlarmNum}</p>
        </div>
        <div className="item">
          <p>已完成</p>
          <p className="num">{statusCount.completedAlarmNum}</p>
        </div>
      </div>
      <div className="content">
        <div className="title">告警信息</div>
        <div className="search-box">
          <div className="search-tabs">
            <div className="label">厂站：</div>
            <div style={{ width: "calc(100% - 50px)" }}>
              <Tabs onTabClick={(key, e) => onTabClick(key, e)}>
                {stationArr.map((item, idx) => (
                  <TabPane
                    tab={`${item.aliasName || item.name}`}
                    key={`tab-` + idx}
                  ></TabPane>
                ))}
              </Tabs>
            </div>
          </div>
          <div>
            <Form
              initialValues={formInitVals}
              layout="inline"
              form={form}
              onValuesChange={onFormLayoutChange}
            >
              <Form.Item label="状态：" name="alarmStatus">
                <Select style={{ width: 120 }} bordered={false}>
                  <Select.Option value={-1}>全部</Select.Option>
                  {alarmStatusOpt.map((item, idx) => {
                    return (
                      <Select.Option value={item.id} key={"form-status-" + idx}>
                        {item.name}
                      </Select.Option>
                    );
                  })}
                </Select>
              </Form.Item>
              <Form.Item label="告警类型：" name="alarmType">
                <Select style={{ width: 120 }} bordered={false}>
                  <Select.Option value={-1}>全部</Select.Option>
                  {alarmTypeOpt.map((item, idx) => {
                    return (
                      <Select.Option value={item.id} key={"form-type-" + idx}>
                        {item.disName}
                      </Select.Option>
                    );
                  })}
                </Select>
              </Form.Item>
              <Form.Item label="告警等级：" name="alarmLevel">
                <Radio.Group>
                  <Radio value={-1}></Radio>
                  <Radio value={2}></Radio>
                  <Radio value={1}></Radio>
                </Radio.Group>
              </Form.Item>
              <Form.Item label="告警时间：" name="queryEndTime">
                <DatePicker.RangePicker
                  style={{ width: "250px" }}
                  format="YYYY-MM-DD"
                  bordered={false}
                />
              </Form.Item>
            </Form>
          </div>
        </div>
        <div className="table-area">
          <div className="table-box">
            <Spin spinning={spinLoading}>
              <div className="table-head">
                <div>厂站</div>
                <div>告警类型</div>
                <div>告警内容</div>
                <div>告警时间</div>
                <div>结束时间</div>
                <div>责任人</div>
                <div>告警等级</div>
              </div>
              <div className="table-body">
                {tableData.length == 0 && !spinLoading && (
                  <div className="noData">- 未查询到符合条件的数据 -</div>
                )}
                {tableData.map((item, idx) => {
                  return (
                    <div
                      className={classnames({
                        row: true,
                        gray: idx > 6,
                        status1: item.alarmStatus * 1 === 0, //未读
                        status2: item.alarmStatus * 1 === 1, //处理中
                        status3: item.alarmStatus * 1 === 2, //已完成
                      })}
                      onClick={() => rowClk(item.id)}
                      key={"table-" + idx}
                    >
                      <div>{item.stationName}</div>
                      <div>{item.alarmTypeName}</div>
                      <div title={item.alarmInfo}>{item.alarmInfo}</div>
                      <div>{item.startTime}</div>
                      <div>{item.endTime || "-"}</div>
                      <div>{item.dutyUserNames}</div>
                      <div>
                        <span
                          className={classnames({
                            warnType: true,
                            red: item.alarmLevel == 2,
                          })}
                        >
                          {item.alarmLevel == 1 ? "黄" : "红"}
                        </span>
                      </div>
                    </div>
                  );
                })}
              </div>
            </Spin>
          </div>
        </div>
        <div className="paging-box">
          <Pagination
            total={total}
            current={formInitVals.pageNum}
            defaultPageSize={formInitVals.pageSize}
            onChange={(page, pSize) => pageChange(page, pSize)}
            showSizeChanger={false}
            showQuickJumper
            showTotal={(total) => `共 ${total} 条`}
          />
        </div>
      </div>

      {/* 故障详情弹窗 */}
      <Modal
        className="warn-page-detail-modal"
        footer={null}
        maskClosable={false}
        closable={false}
        title=""
        open={isShowDetailModal}
      >
        <div className="modal-box">
          <div className="head-tit">
            <div>
              <i className="iconfont iconicon_nav_changzhanguanli_act"></i>
              <b>{alarmDetailData.alarmDetailInfo.stationName}</b>
              <span>/</span>
              <i className="iconfont iconicon_gongyidanyuan_haoyangchi_32"></i>
              <b>{alarmDetailData.alarmDetailInfo.processunitName || "-"}</b>
            </div>
            <i
              className="close-btn iconfont iconguanbi"
              onClick={() => {
                setIsShowDetailModal(false);
                setImgList([]);
                sethandleTxt("");
              }}
            ></i>
          </div>
          <div
            className="modal-content"
            style={{
              bottom:
                alarmDetailData.alarmDetailInfo.alarmStatus != 2 ? "70px" : "0",
            }}
          >
            <div className="base-info-tit">
              <h6>
                <b>{alarmDetailData.alarmDetailInfo.alarmInfo}</b>
                <span
                  className={
                    alarmDetailData.alarmDetailInfo.alarmLevel == 2 ? "red" : ""
                  }
                >
                  {alarmDetailData.alarmDetailInfo.alarmLevel == 1
                    ? "黄色告警"
                    : "红色告警"}
                </span>
              </h6>
              {/* 处理中状态的告警展示关闭按钮 */}
              {(alarmDetailData.alarmDetailInfo.alarmStatus == 1 ||
                alarmDetailData.alarmDetailInfo.alarmStatus == 0) && (
                <button
                  onClick={() => {
                    closeAlarmBtn(alarmDetailData.alarmDetailInfo);
                    getAlarmCount();
                  }}
                >
                  关闭告警
                </button>
              )}
            </div>
            <div className="base-info-con">
              <div className="w270">
                <div className="item">
                  <span className="label">故障编号：</span>
                  <strong>{alarmDetailData.alarmDetailInfo.alarmNum}</strong>
                </div>
                <div className="item">
                  <span className="label">告警时间：</span>
                  <strong>{alarmDetailData.alarmDetailInfo.startTime}</strong>
                </div>
                <div className="item">
                  <span className="label">结束时间：</span>
                  <strong>
                    {alarmDetailData.alarmDetailInfo.endTime
                      ? alarmDetailData.alarmDetailInfo.endTime
                      : "未结束"}
                  </strong>
                </div>
                <div className="item">
                  <span className="label">负责人：</span>
                  <strong>
                    {alarmDetailData.alarmDetailInfo.dutyUserNames}
                  </strong>
                </div>
              </div>
              {alarmDetailData.alarmDetailInfo.alarmTypeName == "水质告警" && (
                <div className="total-img-area">
                  <div id="waterWarningBox"></div>
                </div>
              )}
              {alarmDetailData.alarmDetailInfo.alarmTypeName == "设备告警" && (
                <div className="info-wrap">
                  <div className="info-box">
                    <div className="item">
                      <span className="label">设备名称：</span>
                      <strong>
                        {alarmDetailData.alarmDetailInfo.deviceName || "-"}
                      </strong>
                    </div>
                    <div className="item">
                      <span className="label">历史故障次数：</span>
                      <strong>
                        {alarmDetailData.alarmDetailInfo.historyFaultNum}次
                      </strong>
                    </div>
                    <div className="item">
                      <span className="label">厂家信息：</span>
                      <strong>
                        {alarmDetailData.alarmDetailInfo.factory || "未对接"}
                      </strong>
                    </div>
                    <div className="item">
                      <span className="label">下次保养时间：</span>
                      <strong>
                        {alarmDetailData.alarmDetailInfo.nextMaintainTime}
                      </strong>
                    </div>
                  </div>
                  <div className="img-box">
                    {alarmDetailData.alarmDetailInfo.attach ? (
                      <img
                        src={alarmDetailData.alarmDetailInfo.attach}
                        alt={alarmDetailData.alarmDetailInfo.deviceName}
                      />
                    ) : (
                      <img src={AssetImg} alt="默认图" />
                    )}
                  </div>
                </div>
              )}
            </div>
            <div className="log-area">
              {alarmDetailData.alarmDetailInfo.alarmStatus == 2 && (
                <img className="finish-img" src={finishImg} alt="已完成" />
              )}
              <div className="log-box">
                {alarmDetailData.alarmHandleList.map((item, idx) => {
                  return (
                    <div className="item" key={"log-" + idx}>
                      <div className="date">
                        {item.handleTime.substr(5, 11)}
                      </div>
                      <div
                        className={classnames({
                          con: true,
                          red:
                            idx == alarmDetailData.alarmHandleList.length - 1 &&
                            alarmDetailData.alarmDetailInfo.alarmLevel == 2,
                          yellow:
                            idx == alarmDetailData.alarmHandleList.length - 1 &&
                            alarmDetailData.alarmDetailInfo.alarmLevel == 1,
                          green:
                            alarmDetailData.alarmDetailInfo.alarmStatus == 2 &&
                            idx == 0,
                        })}
                      >
                        {item.handleType == 2 && (
                          <p className="name">{item.handleUserName || "-"}</p>
                        )}
                        <div
                          className={
                            item.handleType == 1 ? "info gray" : "info"
                          }
                        >
                          {item.handleIdea}
                        </div>
                        {item.handleAttach && (
                          <div className="pic-box">
                            {item.handleAttach.split(",").map((mm, idx) => {
                              return (
                                <div className="item" key={"pic-" + idx}>
                                  <img src={mm} />
                                </div>
                              );
                            })}
                          </div>
                        )}
                      </div>
                    </div>
                  );
                })}
              </div>
            </div>
          </div>
          {alarmDetailData.alarmDetailInfo.alarmStatus != 2 && (
            <div className="form-area" style={{ paddingBottom: 20 }}>
              <div className="label">处理意见</div>
              <div className="ipt-box">
                <Input
                  placeholder="请输入"
                  value={handleTxt}
                  onChange={(e) => changeHandleTxt(e)}
                />
                <div className="icon-box" style={{ margin: "15px 0" }}>
                  <Tooltip
                    color="#fff"
                    trigger="click"
                    title={
                      <div className="warn-page-upload-area">
                        <div
                          className="content"
                          style={{
                            height:
                              imgList.length != 0
                                ? imgList.length * 150
                                : "250" + "px",
                          }}
                        >
                          <Upload
                            className="warn-page-upload-box"
                            headers={{
                              authorization: sessionStorage.getItem("token"),
                            }}
                            name="file"
                            action={UPLOADER}
                            listType="picture-card"
                            fileList={imgList}
                            onChange={(e) => handleChange(e)}
                          >
                            {imgList.length >= 9 ? null : (
                              <div className="upload-txt-box">
                                <i className="iconfont iconpiliangdaoru"></i>
                                <div>上传</div>
                              </div>
                            )}
                          </Upload>
                        </div>
                      </div>
                    }
                  >
                    <img src={defaultImg} />
                  </Tooltip>
                </div>
              </div>
              <Button type="primary" onClick={submitHandleLogBtn}>
                提交
              </Button>
            </div>
          )}
        </div>
      </Modal>
    </div>
  );
};

const mapStateToProps = (state) => {
  return {
    ...state.Common,
  };
};

export default connect(mapStateToProps)(Pages);
